import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';
import resize from '@alpinejs/resize'

import 'htmx.org';

import '@splidejs/splide/css';
import Splide from '@splidejs/splide';

import './site/auth';
import './site/theme-switcher';
import './site/awards-search';
import './site/video-library';
import './site/carousels';
import './site/media-gallery';
import './site/instagram-posts';
import './site/splideCenterCarousel';

import.meta.glob([
    '../img/**',
]);

window.Splide = Splide;

window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.plugin(focus);
Alpine.plugin(resize);
Alpine.start();
